import React, { type FC } from 'react'
import { styled } from '@linaria/react'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router'
import { Typography } from '../ui/Typography'
import { ButtonRegular } from '../ui/Button'
import { colors } from '../styles/colors'
import VoteIoSuccess from '../svgr/VoteIoSuccess'
import { profileMyBoxesPagePath } from './ProfilePage'

export const BoxCreateSuccessPage: FC = () => {
  const navigate = useNavigate()

  const handleViewMyBoxes = () => {
    navigate(profileMyBoxesPagePath)
  }

  return (
    <PageContainer>
      <ContentWrapper>
        <IconContainer>
          <VoteIoSuccess />
        </IconContainer>

        <ContentContainer>
          <TitleContainer>
            <Typography fontSize={20} fontWeight={700} color={colors.secondary}>
              <FormattedMessage
                id="dialog.boxCreatedSuccess.title"
                defaultMessage="Бокс успешно создан"
              />
            </Typography>
          </TitleContainer>

          <DescriptionContainer>
            <Typography fontSize={14} fontWeight={400} color={colors.secondary}>
              <FormattedMessage
                id="dialog.boxCreatedSuccess.description"
                defaultMessage="Вы можете поделиться им своим друзьям или создать еще один бокс"
              />
            </Typography>
          </DescriptionContainer>
        </ContentContainer>

        <ButtonsContainer>
          <PrimaryButton
            onClick={handleViewMyBoxes}
            textColor={colors.white}
            textWeight={700}
          >
            <FormattedMessage
              id="dialog.boxCreatedSuccess.viewMyBoxes"
              defaultMessage="Все мои боксы"
            />
          </PrimaryButton>
        </ButtonsContainer>
      </ContentWrapper>
    </PageContainer>
  )
}

export const boxCreateSuccessPagePath = '/box-create-success'

const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100%;
  padding: 24px;
`

const ContentWrapper = styled.div`
  display: grid;
  place-items: center;
  gap: 48px;
  background: ${colors.bgCard};
  padding: 48px 32px;
  width: 100%;
  max-width: 400px;
  text-align: center;
  border-radius: 16px;
`

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 120px;
    height: auto;
  }
`

const ContentContainer = styled.div`
  display: grid;
  gap: 8px;
  max-width: 300px;
`

const TitleContainer = styled.div`
  text-align: center;
`

const DescriptionContainer = styled.div`
  text-align: center;
  line-height: 1.5;
`

const ButtonsContainer = styled.div`
  width: 100%;
  max-width: 280px;
  display: grid;
  gap: 12px;
`

const PrimaryButton = styled(ButtonRegular)`
  width: 100%;
  background: ${colors.secondary};
  color: ${colors.white};
`
